module.exports = __webpack_public_path__ + "media/country_flags/hk-8c8951f1.png";